import React = require("react");

type Props = {
  onClick?: () => void;
};

export class TransparentButton extends React.Component<Props, undefined> {
  render() {
    const { children, onClick } = this.props;

    return (
      <div className="transparent-button" onClick={onClick}>
        {children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/TransparentButton.tsx